import { render } from "./BottomButton.vue?vue&type=template&id=183c32ee"
import script from "./BottomButton.vue?vue&type=script&lang=js"
export * from "./BottomButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__